<mat-paginator 
  #paginator 
  [length]="totalItems" 
  [pageSize]="pageSize"
  (page)="onPageChange($event)" 
  aria-label="Select page of periodic elements"
  showFirstLastButtons>
</mat-paginator>

